// Every account type the app stores. The edit form lists these so it never
// falls back to a default and overwrites the saved type.
export const ACCOUNT_TYPES = [
  { value: 'checking', label: 'Checking' },
  { value: 'savings', label: 'Savings' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'line_of_credit', label: 'Line of Credit' },
  { value: 'loan', label: 'Loan' },
  { value: 'mortgage', label: 'Mortgage' },
  { value: 'investment', label: 'Investment' },
];

export const LIABILITY_TYPES = ['credit_card', 'line_of_credit', 'loan', 'mortgage'];

const label = (v) => String(v).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// Options for the select; a stored type not in the list is kept as its own option.
export function accountTypeOptions(storedType) {
  const v = storedType ? String(storedType) : '';
  if (!v || ACCOUNT_TYPES.some((t) => t.value === v)) return ACCOUNT_TYPES;
  return [...ACCOUNT_TYPES, { value: v, label: label(v) }];
}

export const isLiabilityType = (t) => LIABILITY_TYPES.includes(String(t || '').toLowerCase());
